import React from "react";

import Button from "../../../../../components/elements/Button";
import CustomSelect from "../../../../../components/elements/CustomSelect";

import ValidationCheckEditor from "./ValidationCheckEditor";

import {
    CHECKS_BY_TEMPLATE
} from "../../../../../utils/workspaceTemplates";

import {
    createEmptyTestCase,
    createEmptyValidationCheck
} from "../shared/factories";

export default function ValidationEditor({
                                             workspace,
                                             step,
                                             path,
                                             updateAtPath
                                         }) {


    const testCases = step.testCases || [];

    const addTestCase = () => {

        if (checks.length === 0) {
            window.alert("No validation checks are available for this template.");
            return;
        }

        console.log(testCases);

        updateAtPath(
            [...path, "testCases"],
            [
                ...testCases,
                createEmptyTestCase(checks[0].value)
            ]
        );

    };

    const checks =
        CHECKS_BY_TEMPLATE[workspace.template] || [];

    return (

        <details className="border rounded-md bg-white" open={false}>

            <summary className="cursor-pointer p-5 font-semibold">
                Validation

                <Button onClick={addTestCase}>
                    Add Test Case
                </Button>
            </summary>

            <div className="p-5 flex flex-col gap-6">

                {
                    testCases.map((testCase, testCaseIndex) => (

                        <details
                            key={testCase.id}
                            className="border rounded-lg bg-gray-50"
                        >

                            <summary className="cursor-pointer p-4 font-semibold">
                                <span>Test Case {testCaseIndex + 1}</span>

                                <Button
                                    variant="danger"
                                    onClick={() => {

                                        updateAtPath(
                                            [...path, "testCases"],
                                            testCases.filter((_, i) => i !== testCaseIndex)
                                        );

                                    }}
                                >
                                    Delete
                                </Button>

                            </summary>

                            <div className="p-5 flex flex-col gap-5">

                                {workspace.type === "program" && (

                                    <div className="flex flex-col gap-2">

                                        <label>Program Input (STDIN)</label>

                                        <textarea
                                            rows={5}
                                            className="border rounded-md p-3"
                                            value={testCase.stdin || ""}
                                            onChange={(e) =>
                                                updateAtPath(
                                                    [
                                                        ...path,
                                                        "testCases",
                                                        testCaseIndex,
                                                        "stdin"
                                                    ],
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </div>

                                )}

                                <div className="flex justify-between items-center">

                                    <h5 className="font-medium">
                                        Validation Checks
                                    </h5>

                                    <Button
                                        onClick={() => {

                                            updateAtPath(
                                                [
                                                    ...path,
                                                    "testCases",
                                                    testCaseIndex,
                                                    "validation",
                                                    "checks"
                                                ],
                                                [
                                                    ...testCase.validation.checks,
                                                    {
                                                        ...createEmptyValidationCheck(),
                                                        kind: checks[0].value
                                                    }
                                                ]
                                            );

                                        }}
                                    >
                                        Add Check
                                    </Button>

                                </div>

                                {

                                    testCase.validation.checks.map((check, checkIndex) => (

                                        <ValidationCheckEditor
                                            key={check.id}
                                            check={check}
                                            allowedChecks={checks}
                                            path={[
                                                ...path,
                                                "testCases",
                                                testCaseIndex,
                                                "validation",
                                                "checks",
                                                checkIndex
                                            ]}
                                            updateAtPath={updateAtPath}
                                            onDelete={() => {

                                                updateAtPath(
                                                    [
                                                        ...path,
                                                        "testCases",
                                                        testCaseIndex,
                                                        "validation",
                                                        "checks"
                                                    ],
                                                    testCase.validation.checks.filter(
                                                        (_, i) => i !== checkIndex
                                                    )
                                                );

                                            }}
                                        />

                                    ))

                                }

                            </div>
                        </details>

                    ))
                }

            </div>
        </details>
    );

}